import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { LegType, SourceOptionsType } from '../../models';
import { ConnectedLocationsList } from '../LocationAutocomplete/LocationsList';

const WMPCitiesList = ({ field, citiesIatas, geoLocations, ...options }) => {
    const { displayedWord, onClickItem, isFixedWidth } = options;
    const departureOrArrival = field === 'from' ? LegType.DEPARTURE : LegType.ARRIVAL;
    const locations = citiesIatas.map((iata) => (geoLocations[iata]));

    return (
        <ConnectedLocationsList
            displayedWord={displayedWord}
            departureOrArrival={departureOrArrival}
            suggestionsList={locations}
            onClickItem={onClickItem}
            isFixedWidth={isFixedWidth}
        />
    );
};

const mapStateToProps = (state) => ({
    geoLocations: state.geoLocations.geoLocations,
});

WMPCitiesList.propTypes = {
    ...SourceOptionsType,
    field: PropTypes.oneOf(['from', 'to']).isRequired,
    citiesIatas: PropTypes.array.isRequired,
};

export const ConnectedWMPCitiesList = connect(mapStateToProps, {})(WMPCitiesList);
